import { useCallback, useMemo } from 'react'
import { SEARCH_VERTICALS } from 'constants/search'
import config from 'constants/config'
import { useGlobalVillasAndUniqueStaysSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalVillasAndUniqueStaysSearch'
import VillasTabContent from '../Components/Mobile/TabContents/VillasTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { PROPERTY_TYPE_UNIQUE_STAYS } from 'constants/offer'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineHomeAltIcon from 'components/Luxkit/Icons/line/LineHomeAltIcon'

function useGlobalSearchVerticalTabVillas(searchVerticalItem?: App.SearchVerticalItem): App.GlobalSearchVerticalTabV2 {
  const queryParams = useQueryParams()

  const {
    globalVillasAndUniqueStaysSearchDispatch,
    globalVillasAndUniqueStaysSearchState,
  } = useGlobalVillasAndUniqueStaysSearchContext(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const {
    onSearch,
    context,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalVillasAndUniqueStaysSearchDispatch,
    globalSearchState: globalVillasAndUniqueStaysSearchState,
  })

  const onRequestSearch = useCallback(() => {
    return onSearch({ propertyTypes: [PROPERTY_TYPE_UNIQUE_STAYS] })
  }, [onSearch])

  return useMemo(() => ({
    isEnabled: config.UNIQUE_STAYS_ENABLED && !!searchVerticalItem,
    label: searchVerticalItem?.label ?? 'villas & unique stays',
    key: SEARCH_VERTICALS.VILLAS_AND_UNIQUE_STAYS,
    context,
    onSearch: onRequestSearch,
    ContentComponent: VillasTabContent,
    Icon: LineHomeAltIcon,
  }), [context, onRequestSearch, searchVerticalItem])
}

export default useGlobalSearchVerticalTabVillas
